import Backbone from 'backbone'

// looks at what's being typed into a textarea to see if the textarea needs
// to be taller
var TextArea = Backbone.View.extend({

	events: {
		'input': '_resize'
	},

	render: function() {
		process.nextTick(function() {
			// we need to wait till next tick so we can pick up the css properties
			// of the text area
			this._resize({})
		}.bind(this))
		return this
	},

	_resize: function(e) {
		// #57177 process.nextTick to avoid SQL Console being way too tall on
		// initial page load
		process.nextTick(() => {
			let prevHeight = this.el.style.height
			this.el.style.height = '' // Reset to get correct scrollHeight
			this.el.style.height = this.el.scrollHeight + 'px'
			this.el.style.overflowY = 'hidden'

			// If height has changed, trigger resize
			if (prevHeight != this.el.style.height) {
				this.trigger('resize')
			}
		})
	}
})

export default TextArea


TextArea.__filename__ = 'components/textarea.js'
